import { useI18n } from '@i18n';
import { Tooltip } from '@mui/material';
import { ICONS } from '@/assets/icons';
import Iconify from '@/components/Iconify';
import Label from '@/components/Label';
import { useSession } from '@/components/session/useSession';

type Props = {
  isNewConstruction: boolean;
  isMissingEnergyData: boolean;
};

export function PlannedBuildingLabel({ isNewConstruction, isMissingEnergyData }: Props) {
  const { t } = useI18n();
  const {
    featureFlags: { NEW_CONSTRUCTION },
  } = useSession();

  const isPlanned = NEW_CONSTRUCTION && isNewConstruction;

  if (!isMissingEnergyData && !isPlanned) {
    return null;
  }

  const tooltip = isMissingEnergyData
    ? t('General_MissingEnergyDataBuildingTooltip')
    : t('General_PlannedBuildingTooltip');

  return (
    <Tooltip title={tooltip}>
      <Label
        color="warning"
        variant="soft"
        startIcon={isMissingEnergyData ? <Iconify icon={ICONS.EVA_ALERT_CIRCLE_FILL} /> : undefined}
        sx={{ flexShrink: 0 }}
      >
        {t('General_PlannedBuildings')}
      </Label>
    </Tooltip>
  );
}
